import React from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';

const StatusPage = () => {
    
    const { status } = useParams();
    const location = useLocation();
    const message = (typeof location.state.message === 'string') ? location.state.message : 'Failed to submit, please try again later.';

    return (
        <>
            <div style={{ height: '100vh' }}>
                <div className='position-absolute top-50 start-50 translate-middle text-center shadow p-5 rounded'>
                    <div className={status}>
                        <h2 className='text-dark fs-2 fw-bold text-capitalize'>{status}</h2>
                        <p className='fs-7 text-gray'>{message}</p>
                    </div>
                    <div className='goToHomeBtn rounded  py-2 px-3'>
                        <Link to='/' className='btn btn-danger fw-semibold global-primary-bg m-0 p-0 px-3 py-2 white-text text-decoration-none'>Go To Home Page</Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default StatusPage;